import { useLayoutEffect, useState, type RefObject } from 'react';

/** Tracks an element's border-box height (ResizeObserver). */
export const useMeasuredElementHeight = (
  ref: RefObject<HTMLElement | null>,
): number | undefined => {
  const [height, setHeight] = useState<number | undefined>(undefined);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) {
      return undefined;
    }

    const updateHeight = () => {
      setHeight(element.getBoundingClientRect().height);
    };

    updateHeight();

    if (typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    const observer = new ResizeObserver(updateHeight);
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref]);

  return height;
};
